import { CommonModule } from '@angular/common';
import { Component, inject, input, output } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderComponent } from '@components';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'bo-navigation-buttons',
  templateUrl: './navigation-buttons.component.html',
  standalone: true,
  imports: [
    AngularSvgIconModule,
    CommonModule,
    HeaderComponent,
    TranslateModule,
  ],
})
export class NavigationButtonsComponent {
  label = input.required<string>();
  next = input<string>();
  previous = input<string>();
  nextClicked = output<void>();
  previousClicked = output<void>();

  private router = inject(Router);

  nextPage(): void {
    if (this.next()) {
      this.router.navigate([this.next()], {
        queryParamsHandling: 'preserve',
      });
    }
  }

  previousPage(): void {
    if (this.previous()) {
      this.router.navigate([this.previous()], {
        queryParamsHandling: 'preserve',
      });
    }
  }
}
